import { render, staticRenderFns } from "./recognition-with-core-values.vue?vue&type=template&id=a1dd8e0a&scoped=true&"
import script from "./recognition-with-core-values.vue?vue&type=script&lang=js&"
export * from "./recognition-with-core-values.vue?vue&type=script&lang=js&"
import style0 from "./recognition-with-core-values.vue?vue&type=style&index=0&id=a1dd8e0a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dd8e0a",
  null
  
)

export default component.exports